// extracted by mini-css-extract-plugin
export var attachment = "_r5-a";
export var emailContainer = "_r5-4";
export var emailContentPaddedContainer = "_r5-b";
export var emailHeader = "_r5-6";
export var emailIframe = "_r5-3";
export var emailInfoIcon = "_r5-9";
export var emailShortenedSummary = "_r5-e";
export var infoDropdown = "_r5-0";
export var infoRowBoundedContent = "_r5-d";
export var internal = "_r5-5";
export var merchant = "_r5-8";
export var messageInputContainer = "_r5-h";
export var normal = "_r5-7";
export var replyCard = "_r5-f";
export var subtleButton = "_r5-1";
export var subtleButtonIconContainer = "_r5-2";
export var toggleViewRepliesButton = "_r5-c";
export var wrappingText = "_r5-g";